<template>
  <div class="home" id="content">
    <LogBox
      :showLogs="logs"
      :showObjectives="objectives"
      :showQuests="quests"
      :showDelete="showDelete"
    />
    <br>
    <br>to delete: `. Sometimes requires multiple clicks.
    <br>
    <b-button @click="refresh">Refresh (alt + `)</b-button>
    <b-form-checkbox
      v-model="logs"
      button
      :button-variant="logs? 'danger' : 'primary'"
    >{{logs? 'Hide' : 'Show'}} Logs</b-form-checkbox>
    <b-form-checkbox
      v-model="objectives"
      button
      :button-variant="objectives? 'danger' : 'primary'"
    >{{objectives? 'Hide' : 'Show'}} Objectives</b-form-checkbox>
    <b-form-checkbox
      v-model="quests"
      button
      :button-variant="quests? 'danger' : 'primary'"
    >{{quests? 'Hide' : 'Show'}} Quests</b-form-checkbox>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Vue from "vue";

import LogBox from "@/components/LogBox.vue";

const marked = require("marked");

export default {
  name: "home",
  data() {
    return {
      logs: false,
      quests: false,
      objectives: false,
      showDelete: false
    };
  },
  components: {
    LogBox
  },
  props: {
    showLogs: {
      type: Boolean,
      default: false
    },
    showObjectives: {
      type: Boolean,
      default: false
    },
    showQuests: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.quests = this.showQuests;
    this.logs = this.showLogs;
    this.objectives = this.showObjectives;
  },
  methods: {
    refresh: function() {
      this.$store.dispatch("refreshAll");
    },
    listener: function(e) {
      if (e.keyCode == 192) {
        this.showDelete = !this.showDelete;
      }

      if (e.altKey) {
        if (e.keyCode == 192) {
          console.log("refreshing");
          this.refresh();
        } else if (e.keyCode == 49) {
          this.logs = true;
          this.objectives = false;
          this.quests = false;
        } else if (e.keyCode == 50) {
          this.logs = false;
          this.objectives = true;
          this.quests = false;
        } else if (e.keyCode == 51) {
          this.logs = false;
          this.objectives = false;
          this.quests = true;
        } else if (e.keyCode == 52) {
          this.logs = true;
          this.objectives = true;
          this.quests = true;
        }
      }
    }
  },
  beforeMount() {
    window.addEventListener("keydown", this.listener);
  }
};
</script>

<style lang="scss">
h1 {
  margin: 1em;
}
#content {
  display: block;
  justify-content: flex-start;
  align-items: stretch;
  flex-wrap: wrap;
  margin: 0px auto;
  padding: 20px;
  max-width: 1800px;
}

.left,
.right {
  width: 49%;
  display: inline-block;
  vertical-align: top;
}

.right {
  padding: 3px;
  padding-left: 7px;
}

@media (max-width: 1200px) {
  .card-columns {
    column-count: 1 !important;
  }
}

@media (min-width: 1200px) {
  .card-columns {
    column-count: 2 !important;
  }
}
@media (min-width: 1800px) {
  .card-columns {
    column-count: 3 !important;
  }
}
</style>
